import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map, Observable } from 'rxjs';
import { BlogArticleList } from '../models/blog-entries.interface';
import { HttpParams } from '@angular/common/http';
import { PaginatedItems } from '../models/pagination.interface';
type BlogArticlesListResponse = PaginatedItems<BlogArticleList> & { 
  filterModel: {
    pageIndex: number,
    pageSize: number
  }
}
@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(private apiSvc: ApiService) { }

  getBlogEntries(): Observable<BlogArticleList[]> {
    const size = 3;
    let params = new HttpParams()
      .set('page', 1)
      .set('pageSize', size);
    return this.apiSvc.get<BlogArticlesListResponse>('blog-entries', params).pipe(
      map((res) => res.items.slice(0, size))
    );
  }
}
